import { render, staticRenderFns } from "./AllPolicies.vue?vue&type=template&id=61d1ff39&scoped=true"
import script from "./AllPolicies.vue?vue&type=script&lang=ts"
export * from "./AllPolicies.vue?vue&type=script&lang=ts"
import style0 from "./AllPolicies.vue?vue&type=style&index=0&id=61d1ff39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d1ff39",
  null
  
)

export default component.exports